import React from "react";
import { observer } from "mobx-react";
import locale from "@bonliva-crm/locale";
import { store } from "@store";
import { ErrorCard } from "@components";
import TicketEventLogStore from "./TicketEventLogStore";
import CommentBox from "../CommentBox/CommentBox";
import { EventLogLayout } from "../components/EventLogLayout";
import TicketEvent from "./TicketEvent/TicketEvent";
import { TodoEventType } from "@bonliva-crm/graphql";
import TicketReminderEvent from "@containers/EventLog/TicketEventLog/TicketEvent/TicketReminderEvent";
import TicketLogEvent from "@containers/EventLog/TicketEventLog/TicketEvent/TicketLogEvent";

type Props = {
  commentBoxDisabled: boolean;
  store: TicketEventLogStore;
  onUpload?: () => any;
  uploadDisabled?: boolean;
  disabledText?: string;
};

@observer
class TicketEventLog extends React.Component<Props> {
  componentWillUnmount() {
    this.props.store.unsubscribe();
  }

  renderCustomerCommentBox = () => {
    const { commentBoxDisabled, onUpload, uploadDisabled, disabledText } = this.props;

    return (
      <CommentBox
        disabled={commentBoxDisabled}
        disabledText={disabledText ? disabledText : locale.CustomerCreateEventCondition}
        onComment={(data) => this.props.store.addTicketComment(data.text)}
        onReminder={(data) =>
          this.props.store.addTicketCommentWithReminder(data.text, {
            date: data.remindOn,
            text: data.text,
            assignedUserId: data.assignTo ? data.assignTo._id : null
          })
        }
        onUpload={onUpload}
        smsDisabled={true}
        uploadDisabled={uploadDisabled}
        userName={store().user.name}
        withButtons={["comment", "reminder"]}
        withUpload={false}
        skipReminder
      />
    );
  };

  renderList = () => {
    const { store } = this.props;

    return (
      <div>
        {store.eventsSorted.map((item) => {
          if (item.Type === TodoEventType.Log) {
            return <TicketLogEvent key={item._id} item={item} />;
          }

          if (item.Type === TodoEventType.Reminder) {
            return <TicketReminderEvent key={item._id} item={item} />;
          }

          return (
            <div key={item._id}>
              <TicketEvent item={item} store={store} />
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    if (this.props.store.error) {
      return <ErrorCard message={this.props.store.error.toString()} title="Error" />;
    }

    return (
      <EventLogLayout
        commentBox={this.renderCustomerCommentBox()}
        loading={this.props.store.loading}
        list={this.renderList()}
        search=""
      />
    );
  }
}

export default TicketEventLog;
